import React, { useEffect, useState } from 'react'
// import { useSelector } from 'react-redux'
// import ErrorHandle from '../ErrorHandle.js'
// import Toasts from '../Toasts/Toasts.js'
// import PropTypes from 'prop-types'
// import { JobServiceApi } from '../../API/Job Portal/JobPortal.js'
// import { JobPortals } from '../../Constants/JobPortal.jsx'
import useDebounce from '../../customHooks/useDebounce.js'
import Pagination from '../JobPortal/Pagination.jsx'
import TransactionsTableBodyScreen from './TransactionTableBody.jsx'

const Table = [
  { Label: 'Log id' },
  { Label: 'Login time' },
  { Label: 'Logout time' },
  { Label: 'Computer IP' },
  { Label: 'Activity time' },
]

const TransactionTableData = [
  {
    id: 1,
    logId: '#3066',
    loginTime: '6 Jan 2024 | 8:30 AM',
    logoutTime: '6 Jan 2024 | 6:30 PM',
    computerId: '194.44.203.74',
    activityTime: '06:09:25',
  },
]

const TransactionsScreen = () => {
  // const { frProUser } = useSelector((state) => state.Users)
  // const [toasts, setToasts] = useState([])
  // const [totalPages, setTotalPages] = useState(0)
  // const [, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [size] = useState(10)
  const [getAllApplicationRequested] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const deBounceSearchQuery = useDebounce(searchQuery, 300)
  const [, setInputJobDetails] = useState([])

  // const getAllApplicationRequests = (jobId = null) => {
  //   const reqObj = {
  //     fre8ProAccessToken: frProUser.fre8ProAccessToken,
  //     jobId: jobId,
  //   }

  //   const apiCall =
  //     typeOfJobTab === 'application'
  //       ? JobServiceApi.getAllApplicationRequests
  //       : typeOfJobTab === 'shortlisted'
  //       ? JobServiceApi.getAllShortLasted
  //       : typeOfJobTab === 'declined'
  //       ? JobServiceApi.getAllDeclined
  //       : typeOfJobTab === 'withdrawal'
  //       ? JobServiceApi.getAllWithdrawal
  //       : ''
  //   apiCall(reqObj, page, size)
  //     .then((res) => {
  //       setAllApplicationRequested(res?.data)

  //       handleGuestRequestList(res?.data)
  //       setTotalPages(res?.totalElements)
  //       setLoading(false)
  //     })
  //     .catch((error) => {
  //       let customMessage =
  //         typeOfJobTab === 'application'
  //           ? JobPortals?.HostApplicationRequests?.ApplicationRequestedFailedMessage
  //           : typeOfJobTab === 'shortlisted'
  //           ? JobPortals?.HostShortlistedRequests?.ShortlistedRequestedFailedMessage
  //           : typeOfJobTab === 'declined'
  //           ? JobPortals?.HostDeclinedRequests?.DeclinedRequestedFailedMessage
  //           : typeOfJobTab === 'withdrawal'
  //           ? JobPortals?.HostWithdrawalRequests?.WithdrawalRequestedFailedMessage
  //           : ''
  //       let type =
  //         typeOfJobTab === 'application'
  //           ? JobPortals?.HostApplicationRequests?.ApplicationRequestedType
  //           : typeOfJobTab === 'shortlisted'
  //           ? JobPortals?.HostShortlistedRequests?.ShortlistedRequestedType
  //           : typeOfJobTab === 'declined'
  //           ? JobPortals?.HostDeclinedRequests?.DeclinedRequestedType
  //           : typeOfJobTab === 'withdrawal'
  //           ? JobPortals?.HostWithdrawalRequests?.DeclinedRequestedType
  //           : ''
  //       let color = JobPortals?.JobRequestedFailedColor
  //       ErrorHandle(error, setToasts, customMessage, type, color)
  //     })
  //     .finally(() => {
  //       setLoading(false)
  //     })
  // }

  const handleSearchJob = (e) => {
    setSearchQuery(e?.target?.value ?? '')
  }

  // const handleFindJobByTitleList = (value) => {
  //   let reqObj = {
  //     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
  //     searchTerm: value,
  //   }
  //   const apiCall =
  //     typeOfJobTab === 'application'
  //       ? JobServiceApi.employerAllReceivedFindApplicantByName
  //       : typeOfJobTab === 'shortlisted'
  //       ? JobServiceApi.employerAllShortlistedFindApplicantByName
  //       : typeOfJobTab === 'declined'
  //       ? JobServiceApi.employerAllRejectedFindApplicantByName
  //       : typeOfJobTab === 'withdrawal'
  //       ? JobServiceApi.employerAllWithdrawalFindApplicantByName
  //       : ''
  //   apiCall(reqObj, page, size)
  //     .then((res) => {
  //       setInputJobDetails(res?.data)
  //       setTotalPages(res?.totalElements)
  //     })
  //     .catch((err) => {
  //       let customMessage =
  //         JobPortals?.GustJobPortal?.AllJobServices?.FindAJobFailedMessage
  //       let type = JobPortals?.GustJobPortal?.AllJobServices?.FindJobType
  //       let color = JobPortals?.JobRequestedFailedColor
  //       ErrorHandle(err, setToasts, customMessage, type, color)
  //     })
  //     .finally(() => {
  //       setLoading(false)
  //     })
  // }
  useEffect(() => {
    if (!deBounceSearchQuery || searchQuery?.length <= 2) {
      setInputJobDetails(getAllApplicationRequested)
      return
    }
    // const lowerCaseQuery = deBounceSearchQuery?.toLowerCase()

    // handleFindJobByTitleList(lowerCaseQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deBounceSearchQuery, getAllApplicationRequested])

  return (
    <>
      <main className="main p-0">
        {/* {toasts ? <Toasts toastsList={toasts} /> : null} */}
        <div className="container-fluid p-lg-4">
          <div id="Application_requests" style={{ height: '100%' }}>
            <div className="JOb-portal inptu-title   my-4 ">
              <h3>Transactions</h3>
            </div>
            <div id="Applications_recived">
              <div className="row align-items-center mt-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="w-100"></div>
                  <div className="w-100 d-flex align-items-center justify-content-end gx-3 mb-4 gap-3">
                    <div className=" mb-3 mb-lg-0">
                      <div className="position-relative">
                        <span className="ms-3 position-absolute top-50 translate-middle-y">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none">
                            <path
                              d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                              stroke="#667085"
                              strokeWidth="1.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"></path>
                          </svg>
                        </span>
                        <input
                          onChange={handleSearchJob}
                          type="text"
                          className="form-control ps-5"
                          placeholder="Search transaction"
                        />
                      </div>
                    </div>
                    <div className="mb-3 mb-lg-0 d-flex align-items-center gap-2">
                      <button className="m-0 p-0">
                        <svg
                          width="80"
                          height="40"
                          viewBox="0 0 80 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <g filter="url(#filter0_d_4399_3361)">
                            <rect
                              x="2"
                              y="1"
                              width="76"
                              height="36"
                              rx="8"
                              fill="#fffaeb"></rect>
                            <rect
                              x="2.5"
                              y="1.5"
                              width="75"
                              height="35"
                              rx="7.5"
                              stroke="#fffaeb"></rect>
                            <path
                              d="M22.5376 16.6172C22.4912 16.183 22.2957 15.8449 21.951 15.603C21.6096 15.361 21.1655 15.2401 20.6186 15.2401C20.2341 15.2401 19.9044 15.2981 19.6293 15.4141C19.3542 15.5301 19.1437 15.6875 18.9979 15.8864C18.852 16.0852 18.7775 16.3123 18.7741 16.5675C18.7741 16.7796 18.8222 16.9635 18.9183 17.1193C19.0178 17.2751 19.152 17.4077 19.321 17.517C19.4901 17.6231 19.6773 17.7126 19.8828 17.7855C20.0883 17.8584 20.2955 17.9197 20.5043 17.9695L21.4588 18.2081C21.8433 18.2976 22.2128 18.4186 22.5675 18.571C22.9254 18.7235 23.2453 18.9157 23.527 19.1477C23.812 19.3797 24.0374 19.6598 24.2031 19.9879C24.3688 20.3161 24.4517 20.7005 24.4517 21.1413C24.4517 21.7379 24.2992 22.2633 23.9943 22.7173C23.6894 23.1681 23.2486 23.5211 22.6719 23.7763C22.0985 24.0282 21.4041 24.1541 20.5888 24.1541C19.7966 24.1541 19.1089 24.0315 18.5256 23.7862C17.9455 23.541 17.4915 23.183 17.1634 22.7124C16.8385 22.2417 16.6629 21.6683 16.6364 20.9922H18.451C18.4775 21.3468 18.5869 21.6418 18.7791 21.8771C18.9714 22.1125 19.2216 22.2881 19.5298 22.4041C19.8414 22.5201 20.1894 22.5781 20.5739 22.5781C20.9749 22.5781 21.3262 22.5185 21.6278 22.3991C21.9328 22.2765 22.1714 22.1075 22.3438 21.892C22.5161 21.6733 22.6039 21.4181 22.6072 21.1264C22.6039 20.8613 22.526 20.6425 22.3736 20.4702C22.2211 20.2945 22.0073 20.1487 21.7322 20.0327C21.4605 19.9134 21.1423 19.8073 20.7777 19.7145L19.6193 19.4162C18.7808 19.2008 18.1179 18.8743 17.6307 18.4368C17.1468 17.996 16.9048 17.411 16.9048 16.6818C16.9048 16.0819 17.0672 15.5566 17.392 15.1058C17.7202 14.6551 18.166 14.3054 18.7294 14.0568C19.2929 13.8049 19.9309 13.679 20.6435 13.679C21.366 13.679 21.9991 13.8049 22.5426 14.0568C23.0895 14.3054 23.5187 14.6518 23.8303 15.0959C24.1418 15.5367 24.3026 16.0438 24.3125 16.6172H22.5376ZM29.3972 24.1491C28.6316 24.1491 27.9703 23.9901 27.4135 23.6719C26.86 23.3504 26.4341 22.8963 26.1358 22.3097C25.8375 21.7197 25.6884 21.0253 25.6884 20.2266C25.6884 19.4411 25.8375 18.7517 26.1358 18.1584C26.4374 17.5618 26.8584 17.0978 27.3986 16.7663C27.9389 16.4316 28.5736 16.2642 29.3027 16.2642C29.7734 16.2642 30.2175 16.3404 30.6351 16.4929C31.056 16.642 31.4273 16.8741 31.7488 17.1889C32.0736 17.5038 32.3288 17.9048 32.5144 18.392C32.7 18.8759 32.7928 19.4527 32.7928 20.1222V20.674H26.5336V19.4609H31.0676C31.0643 19.1162 30.9898 18.8097 30.8439 18.5412C30.6981 18.2694 30.4943 18.0556 30.2324 17.8999C29.9739 17.7441 29.6723 17.6662 29.3276 17.6662C28.9597 17.6662 28.6365 17.7557 28.3581 17.9347C28.0797 18.1103 27.8626 18.3423 27.7069 18.6307C27.5544 18.9157 27.4765 19.2289 27.4732 19.5703V20.6293C27.4732 21.0734 27.5544 21.4545 27.7168 21.7727C27.8792 22.0876 28.1062 22.3295 28.3979 22.4986C28.6896 22.6643 29.031 22.7472 29.4221 22.7472C29.6839 22.7472 29.9209 22.7107 30.133 22.6378C30.3451 22.5616 30.5291 22.4505 30.6848 22.3047C30.8406 22.1589 30.9583 21.9782 31.0378 21.7628L32.7182 21.9517C32.6122 22.3958 32.41 22.7836 32.1117 23.1151C31.8167 23.4432 31.4389 23.6984 30.9782 23.8807C30.5175 24.0597 29.9905 24.1491 29.3972 24.1491ZM36.5128 24.1541C36.0289 24.1541 35.593 24.0679 35.2053 23.8956C34.8208 23.7199 34.5159 23.4614 34.2905 23.12C34.0684 22.7786 33.9574 22.3577 33.9574 21.8572C33.9574 21.4264 34.0369 21.0701 34.196 20.7884C34.3551 20.5066 34.5722 20.2812 34.8473 20.1122C35.1224 19.9432 35.4323 19.8156 35.777 19.7294C36.125 19.6399 36.4846 19.5753 36.8558 19.5355C37.3033 19.4891 37.6662 19.4477 37.9446 19.4112C38.223 19.3714 38.4252 19.3118 38.5511 19.2322C38.6804 19.1494 38.745 19.0218 38.745 18.8494V18.8196C38.745 18.4451 38.634 18.1551 38.4119 17.9496C38.1899 17.7441 37.87 17.6413 37.4524 17.6413C37.0116 17.6413 36.6619 17.7375 36.4034 17.9297C36.1482 18.1219 35.9759 18.349 35.8864 18.6108L34.206 18.3722C34.3385 17.9081 34.5573 17.5204 34.8622 17.2088C35.1671 16.8939 35.54 16.6586 35.9808 16.5028C36.4216 16.3438 36.9089 16.2642 37.4425 16.2642C37.8104 16.2642 38.1766 16.3073 38.5412 16.3935C38.9058 16.4796 39.2389 16.6222 39.5405 16.821C39.8421 17.0166 40.084 17.2834 40.2663 17.6214C40.4519 17.9595 40.5447 18.3821 40.5447 18.8892V24H38.8146V22.951H38.755C38.6456 23.1631 38.4915 23.362 38.2926 23.5476C38.0971 23.7299 37.8501 23.8774 37.5518 23.9901C37.2569 24.0994 36.9105 24.1541 36.5128 24.1541ZM36.9801 22.8317C37.3414 22.8317 37.6546 22.7604 37.9197 22.6179C38.1849 22.4721 38.3887 22.2798 38.5312 22.0412C38.6771 21.8026 38.75 21.5424 38.75 21.2607V20.3608C38.6937 20.4072 38.5975 20.4503 38.4616 20.4901C38.3291 20.5298 38.1799 20.5646 38.0142 20.5945C37.8485 20.6243 37.6844 20.6508 37.522 20.674C37.3596 20.6972 37.2188 20.7171 37.0994 20.7337C36.831 20.7701 36.5907 20.8298 36.3786 20.9126C36.1664 20.9955 35.9991 21.1115 35.8764 21.2607C35.7538 21.4065 35.6925 21.5954 35.6925 21.8274C35.6925 22.1589 35.8134 22.4091 36.0554 22.5781C36.2973 22.7472 36.6056 22.8317 36.9801 22.8317ZM42.3544 24V16.3636H44.0994V17.6364H44.179C44.3182 17.1955 44.5568 16.8558 44.8949 16.6172C45.2363 16.3752 45.6257 16.2543 46.0632 16.2543C46.1626 16.2543 46.2737 16.2592 46.3963 16.2692C46.5223 16.2758 46.6267 16.2874 46.7095 16.304V17.9595C46.6333 17.933 46.5123 17.9098 46.3466 17.8899C46.1842 17.8667 46.0268 17.8551 45.8743 17.8551C45.5462 17.8551 45.2512 17.9264 44.9893 18.0689C44.7308 18.2081 44.527 18.402 44.3778 18.6506C44.2287 18.8991 44.1541 19.1858 44.1541 19.5107V24H42.3544ZM50.9217 24.1491C50.1594 24.1491 49.5048 23.9818 48.9579 23.647C48.4144 23.3123 47.9951 22.8499 47.7001 22.2599C47.4084 21.6667 47.2626 20.9839 47.2626 20.2116C47.2626 19.4361 47.4118 18.7517 47.71 18.1584C48.0083 17.5618 48.4293 17.0978 48.9728 16.7663C49.5197 16.4316 50.166 16.2642 50.9118 16.2642C51.5315 16.2642 52.0801 16.3786 52.5574 16.6072C53.0379 16.8326 53.4208 17.1525 53.7058 17.5668C53.9908 17.9777 54.1532 18.4583 54.193 19.0085H52.4728C52.4032 18.6406 52.2375 18.334 51.9757 18.0888C51.7172 17.8402 51.3708 17.7159 50.9366 17.7159C50.5687 17.7159 50.2456 17.8153 49.9672 18.0142C49.6887 18.2098 49.4717 18.4915 49.3159 18.8594C49.1634 19.2273 49.0872 19.6681 49.0872 20.1818C49.0872 20.7022 49.1634 21.1496 49.3159 21.5241C49.4683 21.8954 49.6821 22.1821 49.9572 22.3842C50.2356 22.5831 50.5621 22.6825 50.9366 22.6825C51.2018 22.6825 51.4387 22.6328 51.6475 22.5334C51.8597 22.4306 52.037 22.2831 52.1795 22.0909C52.322 21.8987 52.4198 21.665 52.4728 21.3899H54.193C54.1499 21.9302 53.9908 22.4091 53.7157 22.8267C53.4406 23.241 53.0661 23.5658 52.5922 23.8011C52.1182 24.0331 51.5614 24.1491 50.9217 24.1491ZM57.4705 19.5256V24H55.6708V13.8182H57.4308V17.6612H57.5202C57.6992 17.2304 57.976 16.8906 58.3505 16.642C58.7283 16.3902 59.2089 16.2642 59.7923 16.2642C60.3226 16.2642 60.7849 16.3752 61.1793 16.5973C61.5737 16.8194 61.8787 17.1442 62.0941 17.5717C62.3129 17.9993 62.4222 18.5213 62.4222 19.1378V24H60.6225V19.4162C60.6225 18.9025 60.4899 18.5031 60.2248 18.218C59.9629 17.9297 59.5951 17.7855 59.1211 17.7855C58.8029 17.7855 58.5179 17.8551 58.266 17.9943C58.0174 18.1302 57.8219 18.3274 57.6793 18.5859C57.5401 18.8445 57.4705 19.1577 57.4705 19.5256Z"
                              fill="#000000"></path>
                          </g>
                          <defs>
                            <filter
                              id="filter0_d_4399_3361"
                              x="0"
                              y="0"
                              width="80"
                              height="40"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB">
                              <feFlood
                                floodOpacity="0"
                                result="BackgroundImageFix"></feFlood>
                              <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"></feColorMatrix>
                              <feOffset dy="1"></feOffset>
                              <feGaussianBlur stdDeviation="1"></feGaussianBlur>
                              <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"></feColorMatrix>
                              <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_4399_3361"></feBlend>
                              <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_4399_3361"
                                result="shape"></feBlend>
                            </filter>
                          </defs>
                        </svg>
                      </button>
                      <button className="lightBtn1 m-0 py-2 px-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none">
                          <path
                            d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
                            stroke="#000000"
                            strokeWidth="1.67"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="responsive-tebal overflow-auto rounded-3 billing-table">
                <table className="table border table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      {Table.map((label, index) => {
                        return (
                          <th key={index} scope="col">
                            {index === 0 ? (
                              <div className="form-check mb-0">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="Actions"
                                />
                                <label className="form-check-label " htmlFor="Actions">
                                  {label?.Label}
                                </label>
                              </div>
                            ) : (
                              label?.Label
                            )}
                          </th>
                        )
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {TransactionTableData?.length > 0 ? (
                      TransactionTableData?.map((requests) => (
                        <TransactionsTableBodyScreen
                          key={requests?.couchBookingId}
                          requestObject={requests}
                        // getAllApplicationRequests={getAllApplicationRequests}
                        />
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">
                          <div className="css-dev-only-do-not-override-acm2ia ant-empty ant-empty-normal">
                            <div className="ant-empty-image">
                              <svg
                                width="64"
                                height="41"
                                viewBox="0 0 64 41"
                                xmlns="http://www.w3.org/2000/svg">
                                <g
                                  transform="translate(0 1)"
                                  fill="none"
                                  fillRule="evenodd">
                                  <ellipse
                                    fill="#f5f5f5"
                                    cx="32"
                                    cy="33"
                                    rx="32"
                                    ry="7"></ellipse>
                                  <g fillRule="nonzero" stroke="#d9d9d9">
                                    <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                                    <path
                                      d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                                      fill="#fafafa"></path>
                                  </g>
                                </g>
                              </svg>
                            </div>
                            <div className="ant-empty-description">
                              There are No data listed.
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {TransactionTableData?.length !== 0 ? (
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={Math.ceil(TransactionTableData?.length / size)}
                // totalPages={Math.ceil(totalPages / size)}
                />
              ) : null}
            </div>
            {/* {toasts && <Toasts toastsList={toasts} />} */}
          </div>
        </div>
      </main>
    </>
  )
}

export default TransactionsScreen

// TransactionsScreen.propTypes = {
//   handleGetIndividualGuestReqObjDetails: PropTypes.func,
//   handleTriggerJobTab: PropTypes.func,
//   handleGuestRequestList: PropTypes.func,
//   typeOfJobTab: PropTypes.string,
// }
